var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "voiceScene" } },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "功能学习", name: "zero" } }, [
            _c("div", { staticClass: "iframe-box" }, [
              _c("iframe", {
                attrs: {
                  src: "/tjkStudy/hawkeye/voiceExam",
                  frameborder: "0",
                  width: "100%",
                  height: "100%"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "语音对练", name: "first" } }, [
            _c("div", { staticClass: "priContent" }, [
              _c("div", { staticClass: "prictice" }, [
                _c("div", { staticClass: "imgBox" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/icon_voice.png"),
                      alt: ""
                    }
                  })
                ]),
                _vm._v(" "),
                _vm.step == "first"
                  ? _c(
                      "div",
                      [
                        _vm._l(_vm.priList, function(item, i) {
                          return _c(
                            "div",
                            { key: i },
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v(_vm._s(item.title) + "：")
                              ]),
                              _vm._v(" "),
                              _vm._l(item.tips, function(priItem, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class:
                                      item.title == "操作手册"
                                        ? "value in-block"
                                        : "value"
                                  },
                                  [_vm._v(_vm._s(priItem.value))]
                                )
                              }),
                              _vm._v(" "),
                              item.title == "操作手册"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "goToNewAdd",
                                      staticStyle: { color: "red" },
                                      attrs: {
                                        href:
                                          "https://tjhawkeye.oss-cn-beijing.aliyuncs.com/ts/%E5%AF%B9%E7%BB%83%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf",
                                        target: "_blank"
                                      }
                                    },
                                    [_vm._v("点击查看操作手册")]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "konwBox" }, [
                          _c(
                            "div",
                            {
                              staticClass: "knowBtn",
                              on: { click: _vm.showKnow }
                            },
                            [_vm._v("我已知晓")]
                          )
                        ])
                      ],
                      2
                    )
                  : _vm.step == "second"
                  ? _c("div", { staticClass: "pricComfir" }, [
                      _c("div", { staticClass: "comTitle" }, [
                        _vm._v(" 请输入对练搭档的9位数淘金号： ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content" },
                        [
                          _c("el-input", {
                            staticClass: "input",
                            attrs: { placeholder: "请输入对练搭档的淘金号" },
                            model: {
                              value: _vm.input,
                              callback: function($$v) {
                                _vm.input = $$v
                              },
                              expression: "input"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class: _vm.input
                                ? "comfirmBtn ActiveComBtn"
                                : "comfirmBtn",
                              on: { click: _vm.goToPrict }
                            },
                            [_vm._v("确定")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm.step == "handing"
                  ? _c("div", { staticClass: "handBox" }, [
                      _c("div", { staticClass: "stOrNew" }, [
                        _c(
                          "div",
                          {
                            staticClass: "stopPrict defaultBtn",
                            on: { click: _vm.stopPrict }
                          },
                          [_vm._v("停止对练")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "newPrict defaultBtn",
                            on: { click: _vm.newPrict }
                          },
                          [_vm._v("继续对练")]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "场景考核", name: "third" } },
            [
              !_vm.kaoheList.length
                ? [
                    _c("p", { staticClass: "tj-shift-notice" }, [
                      _vm._v("暂无记录")
                    ])
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "scene-box" },
                      _vm._l(_vm.kaoheList, function(l, key) {
                        return _c("div", { staticClass: "scene" }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toKaoheDetail(l.id)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "zoomImage",
                                style: _vm.style(l.imageUrl)
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass: "title",
                                    attrs: { title: l.name }
                                  },
                                  [_vm._v(_vm._s(l.name))]
                                ),
                                _vm._v(" "),
                                l.exerciseStatus == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "btn",
                                        staticStyle: {
                                          "background-color": "#FF0000"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.stopKaohePrict.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("结束考核")]
                                    )
                                  : _c("div", { staticClass: "btn" }, [
                                      _vm._v("点击进入")
                                    ])
                              ])
                            ]
                          )
                        ])
                      }),
                      0
                    )
                  ]
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("span", [
            _vm._v(
              "是否确定与" +
                _vm._s(_vm.partner.realName) +
                "(" +
                _vm._s(_vm.partner.tjkNumber) +
                ")进行语音对练?"
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.clearSchedule }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2db39f96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db39f96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/newVoiceScene/index.vue
// module id = 1522
// module chunks = 0